import styled from 'styled-components';
import { getBackgroundColor, getBorderColor, getMediaQuery, getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import Box from '../../atoms/Box';
import Image from '../../atoms/ResponsiveImage';
import Text from '../../atoms/Text';
export const Container = styled.div`
  background-color: ${props => getBackgroundColor('white')(props)};
  padding: 16px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${getMediaQuery('large')} {
    padding: 0;
  }
`;
export const Divider = styled(Box)`
  border-bottom: 3px solid ${props => getBorderColor('light')(props)};
  width: 100%;
`;
export const Line = styled(Box)`
  display: flex;
  align-items: center;

  ${getMediaQuery('large')} {
    &,
    & + div {
      display: none;
    }
  }
`;
export const TitleReviewCharacteristics = styled(Text)`
  margin-bottom: 16px;
  font-size: ${props => themeGet('fontSizes.3')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};

  ${getMediaQuery('large')} {
    align-self: self-start;
  }
`;
export const SelectReviewSort = styled(Box)`
  ${getMediaQuery('large')} {
    align-self: self-end;
    padding: 12px;
  }
`;
export const ReviewList = styled.ul`
  width: 100%;
`;
export const Button = styled.button`
  outline: none;
  border-radius: 2px;
  padding: 10px 15px;
  height: 48px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  line-height: 1.5;
  width: 250px;
  margin-bottom: 10px;

  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  background-color: ${props => getBackgroundColor('white')(props)};
  border-color: ${props => getBorderColor('base')(props)};
  color: ${props => getTextColor('base')(props)};
  text-transform: uppercase;
  border: 1px solid ${props => getBorderColor('light')(props)};
`;
export const Title = styled(Text)`
  max-width: 200px;
  margin-left: 10px;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getTextColor('base')(props)};
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
`;
export const ImageItem = styled(Image)`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;